import type {CrmMailboxActions} from 'src/action-creators/crm-mailbox/email-sync';
import type {CrmMailboxSettingsActions} from 'src/action-creators/crm-mailbox/email-settings';
import type {UserMailboxActions} from 'src/action-creators/crm-mailbox/mailbox';
import type {
  UserMailbox,
  EmailSyncStatus,
  EmailProvider,
  Thread,
  Candidate,
  EmailMessage,
  UserProfile,
} from 'src/types/crm-mailbox';
import {
  USER_MAILBOX,
  EMAIL_PROVIDERS,
  EMAIL_SYNC_START,
  EMAIL_SYNC_ERROR,
} from 'src/action-creators/crm-mailbox/email-sync';
import {
  GET_MAILBOX_THREADS,
  GET_CANDIDATE_DETAILS,
  GET_EMAIL_MESSAGES,
  UPDATE_THREAD_READ_STATUS,
} from 'src/action-creators/crm-mailbox/mailbox';
import {USER_PROFILE} from 'src/action-creators/crm-mailbox/email-settings';


type CrmMailboxState = {
  userMailboxes: UserMailbox[] | null | undefined;
  emailProviders: EmailProvider[] | null | undefined;
  userSyncStatus: EmailSyncStatus | null | undefined;
  threads: Thread[] | null | undefined;
  candidate: Candidate | null | undefined;
  emailSyncError: string | null | undefined;
  emailMessages: EmailMessage[] | null | undefined;
  userProfile: UserProfile | null | undefined;
};

const initialState: CrmMailboxState = {
  emailProviders: null,
  userSyncStatus: null,
  userMailboxes: null,
  threads: null,
  candidate: null,
  emailSyncError: null,
  emailMessages: null,
  userProfile: null,
};

export default (
  state: CrmMailboxState = initialState,
  action: CrmMailboxActions | CrmMailboxSettingsActions | UserMailboxActions,
): CrmMailboxState => {
  switch (action.type) {
    case USER_MAILBOX:
      return {...state, userMailboxes: action.payload};
    case EMAIL_PROVIDERS:
      return {...state, emailProviders: action.payload};
    case EMAIL_SYNC_START:
      return {...state, userSyncStatus: action.payload};
    case EMAIL_SYNC_ERROR:
      return {...state, emailSyncError: action.payload};
    case GET_MAILBOX_THREADS:
      return {
        ...state,
        threads:
          action.meta.pageNumber === 0
            ? action.payload // Reset threads if pageNumber is 0
            : state.threads
            ? [
                ...new Map(
                  [...state.threads, ...action.payload].map((thread) => [
                    thread.id,
                    thread,
                  ]),
                ).values(),
              ]
            : action.payload,
      };
    case GET_CANDIDATE_DETAILS:
      return {...state, candidate: action.payload};
    case GET_EMAIL_MESSAGES:
      return {...state, emailMessages: action.payload};
    case USER_PROFILE:
      return {...state, userProfile: action.payload};
    // @ts-expect-error - TS2678 - Type '"crm-mailbox/update-thread-read-status"' is not comparable to type '"crm-mailbox/user-emails" | "crm-mailbox/email-providers" | "crm-mailbox/email-sync-start" | "crm-mailbox/email-sync-error" | "crm-mailbox/user-profile" | "crm-mailbox/error" | ... 4 more ... | "crm-mailbox/send-mail"'.
    case UPDATE_THREAD_READ_STATUS:
      return {
        ...state,
        threads: state.threads?.map((thread: Thread) =>
          // @ts-expect-error - TS2339 - Property 'payload' does not exist on type 'never'.
          thread.id === action.payload.threadId
            ? // @ts-expect-error - TS2339 - Property 'payload' does not exist on type 'never'.
              {...thread, read: action.payload.readStatus}
            : thread,
        ),
      };
    default:
      return {...state};
  }
};
